import React from 'react';
import { PropTypes } from 'prop-types';
import { Form } from 'formik';
import ScrollToError from '@atoms/ScrollToError';

const EditProfileForm = ({ children }) => (
    <Form noValidate style={{ display: 'flex', flexDirection: 'column' }}>
        <ScrollToError>{children}</ScrollToError>
    </Form>
);

EditProfileForm.propTypes = {
    children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]),
};

export default EditProfileForm;
